import styled from 'styled-components'

import { zIndexLevel } from '@/utils'

const Mask = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: ${({ zIndex = zIndexLevel.L10 }) => zIndex};
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ background = 'rgba(0,0,0,0.4)' }) => background};
`

export { Mask }
